/* eslint-disable react-hooks/exhaustive-deps */
import sweetAlert from "components/sweet-alert";
import { useContext, useEffect } from "react";
import { useGetApplicationSettings } from "services/common";
import AuthContext, { appLogout } from "store/auth-context";

export default function LoginAgreement() {
  const authCtx = useContext(AuthContext);
  const { mutate: getAppSettings, data: appSettingsRes } =
    useGetApplicationSettings();
  useEffect(() => {
    getAppSettings();
  }, []);

  useEffect(() => {
    if (appSettingsRes) {
      const messageObj = appSettingsRes.data;

      sweetAlert({
        title: "User Agreement",
        text: messageObj.logonMessage,
        showCancelButton: true,
        confirmButtonText: "Agree",
        cancelButtonText: "Cancel",
        onConfirm: () => {
          authCtx.verifyUser();
        },
        onCancel: () => {
          debugger;
          authCtx.logout();
        },
      });
    }
  }, [appSettingsRes]);
  return <div className="w-[100vw] h-[100vh] bg-white" />;
}
